/**
 * @generated SignedSource<<6ae122609c2e6ba8db3ef25260e23302>>
 * @relayHash f37269aea394a7346ca66d0ed6e8b76f
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/581.0.0-2026-10-13T13:14:19.201Z/buildItemsGridDataMoreQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type buildItemsGridDataMoreQuery$variables = {
  abTestList?: ReadonlyArray<string | null> | null;
  bestsellingDesignsCount: number;
  excellentValuesCount: number;
  homepageId: string;
  isTrade: boolean;
  mostSavedCount: number;
  mostSavedPageStartOffset: number;
  priceBookName: string;
  recommendationItemIds: ReadonlyArray<string>;
  useRecommendationItems: boolean;
  userType: string;
};
export type buildItemsGridDataMoreQuery$data = {
  readonly viewer: {
    readonly bestsellingDesigns?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly serviceId: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemsGridContent_item" | "hpSharedItemsGridTracking_item">;
        } | null;
      } | null> | null;
    } | null;
    readonly excellentValues?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly serviceId: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemsGridContent_item" | "hpSharedItemsGridTracking_item">;
        } | null;
      } | null> | null;
    } | null;
    readonly homepage: {
      readonly modules: ReadonlyArray<{
        readonly items?: ReadonlyArray<{
          readonly cta: string | null;
          readonly header: string | null;
          readonly imageUrl: string | null;
          readonly linkData: {
            readonly path: string | null;
          };
          readonly title: string | null;
        } | null> | null;
        readonly type?: string | null;
      } | null> | null;
    } | null;
    readonly mostSavedItems?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly serviceId: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemsGridContent_item" | "hpSharedItemsGridTracking_item">;
        } | null;
      } | null> | null;
    } | null;
    readonly recommendationItems?: ReadonlyArray<{
      readonly __typename: "Item";
      readonly serviceId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemsGridContent_item" | "hpSharedItemsGridTracking_item">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemsGridContent_viewer">;
  };
};
export type buildItemsGridDataMoreQuery = {
  response: buildItemsGridDataMoreQuery$data;
  variables: buildItemsGridDataMoreQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": ([]/*:: as any*/),
  "kind": "LocalArgument",
  "name": "abTestList"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bestsellingDesignsCount"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excellentValuesCount"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "homepageId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mostSavedCount"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mostSavedPageStartOffset"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recommendationItemIds"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useRecommendationItems"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userType"
},
v11 = [
  {
    "kind": "Variable",
    "name": "abTestList",
    "variableName": "abTestList"
  },
  {
    "kind": "Variable",
    "name": "rootId",
    "variableName": "homepageId"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userType",
          "variableName": "userType"
        }
      ],
      "concreteType": "EditorialItem",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v12/*:: as any*/),
        (v13/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cta",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            (v14/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EditorialModule",
  "abstractKey": null
},
v16 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "mostSavedCount"
  },
  {
    "kind": "Literal",
    "name": "module",
    "value": "MOST_SAVED_MODULE"
  },
  {
    "kind": "Literal",
    "name": "page",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "pageStartOffset",
    "variableName": "mostSavedPageStartOffset"
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browseUrl",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryCode",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceTrackingParams",
  "storageKey": null
},
v21 = {
  "kind": "InlineDataFragmentSpread",
  "name": "hpSharedItemsGridTracking_item",
  "selections": [
    (v17/*:: as any*/),
    (v18/*:: as any*/),
    (v19/*:: as any*/),
    (v20/*:: as any*/)
  ],
  "args": null,
  "argumentDefinitions": ([]/*:: as any*/)
},
v22 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v23 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v24 = {
  "args": [
    (v22/*:: as any*/),
    (v23/*:: as any*/)
  ],
  "kind": "FragmentSpread",
  "name": "HpSharedItemsGridContent_item"
},
v25 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ItemSearchTreandingEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Item",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v17/*:: as any*/),
          (v21/*:: as any*/),
          (v24/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v26 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "excellentValuesCount"
  },
  {
    "kind": "Literal",
    "name": "module",
    "value": "EXCELLENT_VALUES_MODULE"
  }
],
v27 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "bestsellingDesignsCount"
  },
  {
    "kind": "Literal",
    "name": "module",
    "value": "BEST_SELLING_MODULE"
  }
],
v28 = [
  {
    "kind": "Variable",
    "name": "itemIds",
    "variableName": "recommendationItemIds"
  }
],
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v31 = {
  "alias": "productPhotos",
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 1
    }
  ],
  "concreteType": "ItemPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "masterOrZoomPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smallPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhotoVersion",
      "kind": "LinkedField",
      "name": "versions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "webPath",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v30/*:: as any*/)
  ],
  "storageKey": "photos(limit:1)"
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedPdpUrl",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "kind": "LinkedField",
  "name": "measurement",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "addLabel",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "height",
            "width",
            "depth",
            "diameter",
            "length"
          ]
        },
        {
          "kind": "Literal",
          "name": "separator",
          "value": " "
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "kind": "LinkedField",
      "name": "display",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit",
          "storageKey": null
        },
        (v33/*:: as any*/)
      ],
      "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\",\"length\"],separator:\" \")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSize",
      "kind": "LinkedField",
      "name": "size",
      "plural": false,
      "selections": [
        (v33/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArt",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemClassification",
  "kind": "LinkedField",
  "name": "classification",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creationDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemCreator",
  "kind": "LinkedField",
  "name": "creators",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Creator",
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": [
        (v37/*:: as any*/),
        (v30/*:: as any*/)
      ],
      "storageKey": null
    },
    (v30/*:: as any*/)
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    (v14/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLinkable",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMultiSku",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRingItem",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "VariableAttribute",
  "kind": "LinkedField",
  "name": "variableAttributes",
  "plural": true,
  "selections": [
    (v17/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "VariableAttributeSortType",
      "kind": "LinkedField",
      "name": "variableAttributeData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SwatchSort",
          "kind": "LinkedField",
          "name": "swatchSort",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Swatch",
              "kind": "LinkedField",
              "name": "swatch",
              "plural": false,
              "selections": [
                (v17/*:: as any*/),
                (v37/*:: as any*/),
                (v12/*:: as any*/),
                (v30/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v30/*:: as any*/)
  ],
  "storageKey": null
},
v43 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  }
],
v44 = {
  "alias": null,
  "args": [
    (v22/*:: as any*/),
    {
      "kind": "Literal",
      "name": "page",
      "value": "searchAndBrowse"
    },
    (v23/*:: as any*/)
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "convertedAmountList",
      "plural": true,
      "selections": (v43/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "originalConvertedAmountList",
      "plural": true,
      "selections": (v43/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quantityDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "percentageOff",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "textType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amountType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showPriceLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showPriceVariability",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vertical",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "ShipmentQuote",
  "kind": "LinkedField",
  "name": "shipmentQuotes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isComplimentary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCalculated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "totalAmount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ConvertedAmounts",
          "kind": "LinkedField",
          "name": "convertedAmounts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "USD",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "kind": "LinkedField",
      "name": "serviceMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Region",
          "kind": "LinkedField",
          "name": "region",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "regionName",
              "storageKey": null
            },
            (v30/*:: as any*/)
          ],
          "storageKey": null
        },
        (v30/*:: as any*/)
      ],
      "storageKey": null
    },
    (v30/*:: as any*/)
  ],
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewDisplayType",
  "kind": "LinkedField",
  "name": "quickViewDisplay",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewParagraph",
      "kind": "LinkedField",
      "name": "paragraphs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": "mobileText",
          "args": [
            {
              "kind": "Literal",
              "name": "formatType",
              "value": "MOBILE"
            }
          ],
          "kind": "ScalarField",
          "name": "text",
          "storageKey": "text(formatType:\"MOBILE\")"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewCreator",
      "kind": "LinkedField",
      "name": "creators",
      "plural": true,
      "selections": [
        (v37/*:: as any*/),
        (v39/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewCategorySegments",
      "kind": "LinkedField",
      "name": "paragraphAttributeNames",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "period",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "origin",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "style",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "periodPrefix",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v48 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ItemSearchTreandingEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Item",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v17/*:: as any*/),
          (v18/*:: as any*/),
          (v19/*:: as any*/),
          (v20/*:: as any*/),
          (v31/*:: as any*/),
          (v32/*:: as any*/),
          (v34/*:: as any*/),
          (v35/*:: as any*/),
          (v13/*:: as any*/),
          (v36/*:: as any*/),
          (v38/*:: as any*/),
          (v39/*:: as any*/),
          (v40/*:: as any*/),
          (v41/*:: as any*/),
          (v42/*:: as any*/),
          (v44/*:: as any*/),
          (v45/*:: as any*/),
          (v46/*:: as any*/),
          (v47/*:: as any*/),
          (v30/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      (v7/*:: as any*/),
      (v8/*:: as any*/),
      (v9/*:: as any*/),
      (v10/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "buildItemsGridDataMoreQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HpSharedItemsGridContent_viewer"
          },
          {
            "alias": null,
            "args": (v11/*:: as any*/),
            "concreteType": "Homepage",
            "kind": "LinkedField",
            "name": "homepage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  (v15/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "condition": "useRecommendationItems",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": "mostSavedItems",
                "args": (v16/*:: as any*/),
                "concreteType": "ItemSearchTreandingConnection",
                "kind": "LinkedField",
                "name": "itemSearchTrending",
                "plural": false,
                "selections": (v25/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": "excellentValues",
                "args": (v26/*:: as any*/),
                "concreteType": "ItemSearchTreandingConnection",
                "kind": "LinkedField",
                "name": "itemSearchTrending",
                "plural": false,
                "selections": (v25/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": "bestsellingDesigns",
                "args": (v27/*:: as any*/),
                "concreteType": "ItemSearchTreandingConnection",
                "kind": "LinkedField",
                "name": "itemSearchTrending",
                "plural": false,
                "selections": (v25/*:: as any*/),
                "storageKey": null
              }
            ]
          },
          {
            "condition": "useRecommendationItems",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "recommendationItems",
                "args": (v28/*:: as any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "itemRead",
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v29/*:: as any*/),
                      (v17/*:: as any*/),
                      (v21/*:: as any*/),
                      (v24/*:: as any*/)
                    ],
                    "type": "Item",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*:: as any*/),
      (v4/*:: as any*/),
      (v3/*:: as any*/),
      (v10/*:: as any*/),
      (v0/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      (v2/*:: as any*/),
      (v1/*:: as any*/),
      (v9/*:: as any*/),
      (v8/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "buildItemsGridDataMoreQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v11/*:: as any*/),
            "concreteType": "Homepage",
            "kind": "LinkedField",
            "name": "homepage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  (v29/*:: as any*/),
                  (v15/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v30/*:: as any*/),
          {
            "condition": "useRecommendationItems",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": "mostSavedItems",
                "args": (v16/*:: as any*/),
                "concreteType": "ItemSearchTreandingConnection",
                "kind": "LinkedField",
                "name": "itemSearchTrending",
                "plural": false,
                "selections": (v48/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": "excellentValues",
                "args": (v26/*:: as any*/),
                "concreteType": "ItemSearchTreandingConnection",
                "kind": "LinkedField",
                "name": "itemSearchTrending",
                "plural": false,
                "selections": (v48/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": "bestsellingDesigns",
                "args": (v27/*:: as any*/),
                "concreteType": "ItemSearchTreandingConnection",
                "kind": "LinkedField",
                "name": "itemSearchTrending",
                "plural": false,
                "selections": (v48/*:: as any*/),
                "storageKey": null
              }
            ]
          },
          {
            "condition": "useRecommendationItems",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "recommendationItems",
                "args": (v28/*:: as any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "itemRead",
                "plural": true,
                "selections": [
                  (v29/*:: as any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v17/*:: as any*/),
                      (v18/*:: as any*/),
                      (v19/*:: as any*/),
                      (v20/*:: as any*/),
                      (v31/*:: as any*/),
                      (v32/*:: as any*/),
                      (v34/*:: as any*/),
                      (v35/*:: as any*/),
                      (v13/*:: as any*/),
                      (v36/*:: as any*/),
                      (v38/*:: as any*/),
                      (v39/*:: as any*/),
                      (v40/*:: as any*/),
                      (v41/*:: as any*/),
                      (v42/*:: as any*/),
                      (v44/*:: as any*/),
                      (v45/*:: as any*/),
                      (v46/*:: as any*/),
                      (v47/*:: as any*/)
                    ],
                    "type": "Item",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v30/*:: as any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/581.0.0-2026-10-13T13:14:19.201Z/buildItemsGridDataMoreQuery",
    "metadata": {},
    "name": "buildItemsGridDataMoreQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "dc46fea8c3f36bd9be047d7bdf62c601";

export default node;
